import styled from 'styled-components'

const SingleConProStyle = styled.div.attrs()`
	padding: var(--sp4x);
	padding-bottom:var(--sp2x);
	border-radius: 10px;
	background-color: var(--white);

	&:not(:first-child) {
		margin-top: 4px;
	}

	.title {
		margin-bottom: var(--sp3x);
		overflow-wrap: anywhere;
	}

	.footer {
		padding-top: var(--sp3x);
		padding-bottom: var(--sp2x);
		border-top: 1px solid var(--lightGrey);

		.review-cont {
			position: relative;
			display: flex;
			align-items: center;

            @media screen and (min-width:${(props) => props.theme.mediaQuery.TabletSize}){
                &:hover {
                    .review-popup {
                        opacity: 1;
						pointer-events:all;
                    }
                }
            }
            

			.review-popup {
				position: absolute;
				bottom: 100%;
				padding: 14px;
				border: 2px solid var(--purple);
				border-radius: 8px;
				background-color: var(--white);
				opacity: 0;
				transition: 0.3s;
				pointer-events:none;
				
                &.active {
					opacity: 1;
					pointer-events:all;
                }

				& > span {
					display: flex;
					align-items: center;
					padding: var(--spSize) 12px;
					transition: 0.3s;
					border-radius: 8px;
					cursor: pointer;

					&:hover {
						background-color: #f9f5fe;
					}

					.imageCont {
						width: var(--sp3x);
						height: var(--sp3x);
						margin-right: var(--spSize);
					}
				}
			}
		}

		.likes {
			margin-right: var(--sp3x);
		}

		.like-dislike {
			margin-right: var(--sp3x);
			max-width: var(--sp12x);
		}

		.author {
			margin-left: auto;

			.imageCont {
				width: var(--sp4x);
				height: var(--sp4x);
				border: 2px solid var(--white);
				border-radius: 50%;
				overflow: hidden;
				margin-right: var(--sp2x);
			}

			i {
				font-size: var(--sp2x);
			}

			.blockk {
                position: relative;

                &.share {
                    margin:0 var(--spSize);
                }

                .pop {
                    padding: var(--sp4x);
                    background-color: var(--white);
                    border-radius: 15px;
                    position: absolute;
                    right:0;
                    top: calc(100% + var(--sp1-5x));
                    box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
                    opacity: 0;
                    transition: 0.3s;
                    pointer-events: none;
                    z-index: 10;

                    .sharer {
                        transition:var(--trTime);
                        &:hover {
                            color:var(--purple);
                        }
                    }

                    &.active {
                        pointer-events: all;
                        opacity: 1;
                    }

                    a,.comp-title {
                        white-space: nowrap;
                        
                        &:not(:first-child){
                            margin-top: var(--sp2x);
                        }
                    }

                    .comp-title {
                        &:nth-child(2) {
                            margin: var(--sp2x) 0;
                        }
                    }
                }
            }
		}
	}

	.head {
		margin: 0 0 var(--sp3x);
		padding-top:var(--sp4x);
		border-top: 1px solid var(--lightGrey);
	}

	.single-comment {
		padding-bottom: var(--sp3x);
		margin-bottom: var(--sp3x);
		border-bottom: 1px solid var(--lightGrey);

		.blockk {
			position: relative;

			&.share {
				margin:0 var(--spSize);
			}

			.pop {
				padding: var(--sp4x);
				background-color: var(--white);
				border-radius: 15px;
				position: absolute;
				right:0;
				top: calc(100% + var(--sp1-5x));
				box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
				opacity: 0;
				transition: 0.3s;
				pointer-events: none;
				z-index: 10;

				.sharer {
					transition:var(--trTime);
					&:hover {
						color:var(--purple);
					}
				}

				&.active {
					pointer-events: all;
					opacity: 1;
				}

				a,.comp-title {
					white-space: nowrap;
					
					&:not(:first-child){
						margin-top: var(--sp2x);
					}
				}

				.comp-title {
					&:nth-child(2) {
						margin: var(--sp2x) 0;
					}
				}
			}
		}
		
		.hdr {
			.name-pic {
				.imageCont {
					width: var(--sp4x);
					height: var(--sp4x);
					border: 2px solid var(--white);
					border-radius: 50%;
					overflow: hidden;
					margin-right: var(--sp2x);
				}
			}

			.date {
				i {
					margin-left: var(--sp2x);
					font-size: var(--sp2x);
				}
			}
		}

		.const14 {
			padding: var(--sp2x) 0;
		}

		.ftr {
			.likes {
				margin-right: var(--sp2x);
			}

			i {
				font-size: var(--sp2x);

				&:before {
					color: var(--grey);
				}
			}

			.reply {
				transition: var(--trTime);
				
				&:hover {
					color:var(--lightBlue);
				}
				
				.comp-title {
					margin-left: var(--sp2x);
				}
			}
		}
	}

	.ant-form-item {
		margin-bottom: 0;
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
		padding: var(--sp2-5x);
		border-radius: 10px;

		.title {
			margin-bottom: var(--sp2x);
		}

		.footer {
			padding-top:var(--sp2x);
			padding-bottom:var(--spSize);
			
			.review-cont {

				.review-popup {
					padding: 8px 0;
                    max-width: calc(100vw - var(--sp4x));
                    left:-20px;

					& > span {
						padding: 6px 12px;
					}
				}
			}
		}
	}
`

export default SingleConProStyle
